import React, { useEffect, useState } from "react";
import "./BlackRothAnimation.css";

const LETTERS = ["A" ,"I", "\u00A0 " ,"F", "u", "e", "l", ".", "T", "h","e","\u00A0","F","u","t","u","r","e","\u00A0","E","n","g","i","n","e"];




const BlackRothAnimation = () => {
  const [phase, setPhase] = useState("blank");

  useEffect(() => {
    const runAnimation = () => {
      setPhase("blank");

      const timeouts = [
        setTimeout(() => setPhase("seed-one"), 120),
        setTimeout(() => setPhase("seed-two"), 200),
        setTimeout(() => setPhase("pair-one"), 480),
        setTimeout(() => setPhase("pair-two"), 680),
        setTimeout(() => setPhase("outer"), 880),
        setTimeout(() => setPhase("final"), 1100),
      ];

      return timeouts;
    };

    let timeouts = runAnimation();

    const interval = setInterval(() => {
      timeouts.forEach(clearTimeout);
      timeouts = runAnimation();
    }, 1600);

    return () => {
      clearInterval(interval);
      timeouts.forEach(clearTimeout);
    };
  }, []);

  const getLetterClass = (index) => {
    if (phase === "blank") return "blackroth-letter is-hidden";

    if (phase === "seed-one") {
      return index === 4
        ? "blackroth-letter is-early"
        : "blackroth-letter is-hidden";
    }

    if (phase === "seed-two") {
      if (index === 4) return "blackroth-letter is-dim";
      if (index === 6) return "blackroth-letter is-early";
      return "blackroth-letter is-hidden";
    }

    if (phase === "pair-one") {
      if (index === 4) return "blackroth-letter is-bright";
      if (index === 6) return "blackroth-letter is-dim";
      if (index === 5 || index === 7) return "blackroth-letter is-early";
      return "blackroth-letter is-hidden";
    }

    if (phase === "pair-two") {
      if (index === 4 || index === 6) return "blackroth-letter is-bright";
      if (index === 5 || index === 7) return "blackroth-letter is-dim";
      if (index === 2 || index === 3) return "blackroth-letter is-early";
      return "blackroth-letter is-hidden";
    }

    if (phase === "outer") {
      if (index === 0 || index === 1 || index === 8)
        return "blackroth-letter is-early";
      if (index === 2 || index === 3 || index === 5 || index === 7)
        return "blackroth-letter is-dim";
      if (index === 4 || index === 6) return "blackroth-letter is-bright";
      return "blackroth-letter is-hidden";
    }

    return "blackroth-letter is-final";
  };

  return (
    <section
      className="blackroth-animation-section"
      aria-label="BlackRoth animation"
    >
      <div className="blackroth-page">
        <div className="blackroth-stage">
          <div className="blackroth-scene">
            {/* ✅ BACKGROUND VIDEO */}
            <video
              className="blackroth-video"
              src="https://blackroth-images.s3.ap-south-1.amazonaws.com/blackroth_animation.mp4"
              autoPlay
              loop
              muted
              playsInline
              preload="auto"
              onEnded={(e) => e.target.play()} // ✅ fallback loop
            />

            {/* ❌ OPTIONAL: remove this if you don’t want particles */}
            {/* <div className="blackroth-globe" aria-hidden="true">
              <div className="blackroth-globe-arc" />
              <div className="blackroth-globe-surface" />
              <div className="blackroth-globe-grid" />

              {PARTICLES.map((particle, index) => (
                <span
                  key={index}
                  className={`blackroth-particle blackroth-particle-${particle.color}`}
                  style={{
                    left: particle.left,
                    top: particle.top,
                    width: `${particle.size}px`,
                    height: `${particle.size}px`,
                  }}
                />
              ))}
            </div> */}

            {/* TEXT */}
            <section className="blackroth-hero">
              <div className="blackroth-wordmark-mask">
                <h2 className="blackroth-wordmark" aria-label="Blackroth">
                  {LETTERS.map((letter, index) => (
                    <span
                      className={getLetterClass(index)}
                      key={`${letter}-${index}`}
                    >
                      {letter}
                    </span>
                  ))}
                </h2>
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlackRothAnimation;
 
